import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './patient-login.css';

import { register_patient } from '../../api';

import CONFIG from '../../config';

function PatientRegistration() {
    const navigate = useNavigate();

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('success');

    const [confirmationCode, setConfirmationCode] = useState('');


    const [pageMode, setPageMode] = useState('register'); // 'register' or 'confirm'

    const handleSubmit = async (event) => {

        const newErrors = {};

        if (!firstName.trim()) {
            newErrors.firstName = 'First Name is required';
        }

        if (!lastName.trim()) {
            newErrors.lastName = 'Last Name is required';
        }

        if (!email.trim()) {
            newErrors.email = 'Email is required';
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                email
            )
        ) {
            newErrors.email =
                'Please enter a valid email address';
        }

        if (!password.trim()) {
            newErrors.password = 'Password is required';
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            return;
        }

        setLoading(true);

        const formData = {
            firstName,
            lastName,
            email,
            password,
        };

        await doSignup();

        // register_patient(formData)
        //     .then((response) => {
        //         console.log(
        //             'Patient registered successfully:',
        //             response
        //         );

        //         setMessage(
        //             'Patient registered successfully!'
        //         );
        //         setMessageType('success');

        //         setFirstName('');
        //         setLastName('');
        //         setEmail('');
        //         setPassword('');
        //     })
        //     .catch((error) => {
        //         console.error(
        //             'Error registering patient:',
        //             error
        //         );

        //         setMessage(
        //             'Error registering patient. Please try again.'
        //         );
        //         setMessageType('error');
        //     })
        //     .finally(() => {
        //         setLoading(false);
        //     });
    };

    async function doSignup() {

        try {
            await cognitoRequest("SignUp", {
                ClientId: CONFIG.userPoolClientId, Username: email, Password: password,
                UserAttributes: [{ Name: "email", Value: email }, { Name: "given_name", Value: firstName }, { Name: "family_name", Value: lastName }],
            });

            setPageMode('confirm');
            //state.username = email;
            showAlert("alert-signup", "Account created! Check your email for the 6-digit confirmation code.", "success");


            setLoading(false);

        } catch (err) {
            setLoading(false);
            showAlert("alert-signup", err.message, "error");
        } finally { }
    };
    async function doConfirm() {

        if (!confirmationCode) { showAlert("alert-confirm", "Enter the 6-digit code", "error"); return; }
        hideAlert("alert-confirm");
        try {
            setLoading(true);
            await cognitoRequest("ConfirmSignUp", { ClientId: CONFIG.userPoolClientId, Username: email, ConfirmationCode: confirmationCode });
            showAlert("alert-confirm", "Account confirmed! You can now sign in.", "success");
            setTimeout(() => navigate(
                '/doctor-login'
            ), 1500);
        } catch (err) {
            setLoading(false);
            showAlert("alert-confirm", err.message, "error");
        }
    }

    function showAlert(id, msg, type = "info") {

        setMessage(msg);
        setMessageType(type);
        setErrors(msg);
    }
    function hideAlert(id) { setErrors(''); }

    async function cognitoRequest(action, body) {
        const res = await fetch(CONFIG.awsUrl, {
            method: "POST",
            headers: { "Content-Type": "application/x-amz-json-1.1", "X-Amz-Target": `AWSCognitoIdentityProviderService.${action}` },
            body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || data.__type || "Cognito error");
        return data;
    }

   

    return (
        <div
            className="page-card centered-card"
            style={{
                maxWidth: '700px',
                margin: '0 auto',
            }}
        >

            {pageMode === 'register' &&
                <div className="padding-lg">
                    <h2 className="page-heading">
                        Register for Wellness Check
                    </h2>

                    <p className="page-copy text-muted">
                        Create your account to access the
                        Wellness Check platform.
                    </p>

                    <div >
                        {/* First Name / Last Name */}
                        <div className="form-row">
                            <div className="form-group">
                                <label className="form-label">
                                    First Name
                                </label>
                                <input
                                    type="text"
                                    value={firstName}
                                    onChange={(e) =>
                                        setFirstName(
                                            e.target.value
                                        )
                                    }
                                    className={`form-control ${errors.firstName
                                        ? 'error-input'
                                        : ''
                                        }`}
                                    placeholder="Enter first name"
                                />
                                {errors.firstName && (
                                    <span className="error-text">
                                        {errors.firstName}
                                    </span>
                                )}
                            </div>

                            <div className="form-group">
                                <label className="form-label">
                                    Last Name
                                </label>
                                <input
                                    type="text"
                                    value={lastName}
                                    onChange={(e) =>
                                        setLastName(
                                            e.target.value
                                        )
                                    }
                                    className={`form-control ${errors.lastName
                                        ? 'error-input'
                                        : ''
                                        }`}
                                    placeholder="Enter last name"
                                />
                                {errors.lastName && (
                                    <span className="error-text">
                                        {errors.lastName}
                                    </span>
                                )}
                            </div>
                        </div>

                        {/* Email */}
                        <div className="form-group">
                            <label className="form-label">
                                Email
                            </label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) =>
                                    setEmail(e.target.value)
                                }
                                className={`form-control ${errors.email
                                    ? 'error-input'
                                    : ''
                                    }`}
                                placeholder="you@example.com"
                            />
                            {errors.email && (
                                <span className="error-text">
                                    {errors.email}
                                </span>
                            )}
                        </div>

                        {/* Password */}
                        <div className="form-group">
                            <label className="form-label">
                                Password
                            </label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) =>
                                    setPassword(
                                        e.target.value
                                    )
                                }
                                className={`form-control ${errors.password
                                    ? 'error-input'
                                    : ''
                                    }`}
                                placeholder="Enter your password"
                            />
                            {errors.password && (
                                <span className="error-text">
                                    {errors.password}
                                </span>
                            )}
                        </div>



                        <button
                            type="button"
                            className="btn btn-primary book-btn"
                            disabled={loading}
                            onClick={() => { handleSubmit(); }}
                            style={{
                                backgroundColor: '#0b5ed7',
                            }}
                        >
                            {loading ? (
                                <span className="spinner"></span>
                            ) : (
                                'Sign In'
                            )}
                        </button>

                        <p className="text-muted text-small mt-3 mb-0">
                            <button
                                type="button"
                                className="link-button"
                                onClick={() =>
                                    navigate(
                                        '/doctor-login'
                                    )
                                }
                            >
                                If you already have an account,
                                click here to login
                            </button>
                        </p>
                    </div>

                </div>
            }

            {pageMode === 'confirm' &&
                <div className="padding-lg">
                    <h2 className="page-heading">
                        Confirmation for your account
                    </h2>
                    <div className="form-group">
                        <label className="form-label">
                            Confirmation Code
                        </label>
                        <input
                            type="text"
                            value={confirmationCode}
                            onChange={(e) =>
                                setConfirmationCode(
                                    e.target.value
                                )
                            }
                            className={`form-control ${errors.confirmationCode
                                ? 'error-input'
                                : ''
                                }`}
                            placeholder="Enter confirmation code"
                        />
                        {errors.confirmationCode && (
                            <span className="error-text">
                                {errors.confirmationCode}
                            </span>
                        )}
                    </div>
                    <div className="form-group">
                        <button
                            type="button"

                            disabled={loading}
                            onClick={() => { doConfirm(); }}
                            className="btn btn-primary book-btn">

                            {loading ? (
                                <span className="spinner"></span>
                            ) : (
                                'Confirm Registration'
                            )}

                        </button>
                    </div>

                </div>
            }


            {message && (
                <div
                    className={`alert-message ${messageType ===
                        'success'
                        ? 'alert-success'
                        : 'alert-error'
                        }`}
                >
                    {message}
                </div>
            )}





        </div>
    );
}

export default PatientRegistration;